import _ = require("underscore");
import Portal = require("portal-gis");
import Utils = require("../utils");
import $ = require("jquery");
import Query = require("arcgis/services/featureserver/query");
import Services = require("../services/ogc/wfs-readers");
import Base = require("./base/geoquery");
import FormTool = require("../controls/ogcwfs-geoquery-form-tool");

class Handler extends Base<{
    out: {
        controller: FormTool;
        command: Portal.CommandLeaf;
    }
}> {

    execute(args = this.args) {

        _.defaults(this.options, {
            event: "geoquery-result",
            "key-template": args.out.controller.options["key-template"]
        });

        // this is a bit mysterious, no?  Why would the control which contains the invoking command contain the serviceInfo
        // instead of this handler, or at the very least, the invoking command?
        // Well, the handler is generic and used by all ogcwfs form searches so the only option is to put it on the command instead.
        // But the controller needs this same info to generate the form, to putting it on the command is redundant.
        // so we're stuck with this as far as I can see...
        let options = this.controller.options;

        Utils.ifOption(options, "typeName", typeName => {
            Utils.ifOption(options, "url", url => {
                let metadata = this.controller.metadata.filter(m => m.type !== null);

                let data = this.asData();
                console.log("data: ", data);

                let query = this.asQuery(data);
                console.log("query: ", query);

                Services.WfsGetFeatureReader.read({
                    url: url,
                    typeName: typeName,
                    filter: query,
                    fields: metadata
                }).done(layer => {
                    this.assignKeys(layer);
                    Utils.ifOption(options, "symbology", v => Utils.extend(layer, { symbology: v }));
                    
                    // TODO: this is not consistant with ips-geoquery-processor, which defers back to the controller
                    // so we don't have to reach into the controller options here...look at the mess that is causing.
                    // struggling with pushing the correct data, not sure where my thinking is wrong,
                    // config is on the form control but I need that data in the handler and this is the point of mediation:
                    this.trigger({
                        filter: data,
                        layers: [layer],
                        metadata: metadata,
                        query: query,
                        typeName: typeName,
                        url: url
                    });

                });
            });
        });

    }

    private get controller() {
        return this.args.out.controller;
    }

    private asData() {
        return this.controller.asData();
    }

    private asQuery(data: Array<{ name: string; value: any; }>) {
        return data.map(item => [item.name, item.value]);
    }

}

export = Handler;  